import packageJson from "../../../package.json";

const RELEASE_NAME_PLACEHOLDER = "{RELEASE_NAME_PLACEHOLDER}";

export function getReleaseName(): string {
  const currentReleaseName = packageJson.releaseName;
  if (currentReleaseName === RELEASE_NAME_PLACEHOLDER) {
    return packageJson.version;
  }

  return currentReleaseName;
}
